import { useAdmin } from "./AdminContext";

// Format "2026-05" -> "May 2026"
const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const fmt = (yyyyMm) => {
  if (!yyyyMm || !/^\d{4}-\d{2}$/.test(yyyyMm)) return yyyyMm || '';
  const [y, m] = yyyyMm.split('-').map(Number);
  return `${MONTH_NAMES[m - 1]} ${y}`;
};

/**
 * Quick month selector dropdown. Shows recent 24 months (current first).
 * `dateFieldOverride` lets a tab pin the fetch to its preferred field
 * (e.g. SignInTab passes 'check_in_date', Billing/Dashboard pass 'check_out_date').
 */
export function MonthDropdown({ dateFieldOverride = null }) {
  const { selectedMonth, recentMonths, handleSelectMonth } = useAdmin();
  return (
    <div className="flex items-center gap-2">
      <label className="text-xs text-vault-text-secondary whitespace-nowrap">Month:</label>
      <select
        value={selectedMonth || ''}
        onChange={(e) => handleSelectMonth(e.target.value, dateFieldOverride)}
        className="h-8 bg-black/40 border border-vault-border rounded px-2 text-sm text-vault-text hover:border-vault-gold focus:outline-none focus:border-vault-gold cursor-pointer"
        data-testid="month-dropdown"
      >
        <option value="" disabled>Select month</option>
        {recentMonths.map((m) => (
          <option key={m} value={m}>{fmt(m)}</option>
        ))}
      </select>
    </div>
  );
}
